<template lang="">
  <div class="footer">
    <footer class=" flex flex-around align-center gWidth" id="footer" v-cloak>
      <a
        href="http://bszs.conac.cn/sitename?method=show&id=2727FDDD40A11C3AE053022819ACCA05"
        target="_blank"
      >
        <img src="@/assets/red.png" alt="" class="img1" />
      </a>

      <div class="btms">
        <div class="footer_btm">
          <div
            class="margin-bottom-sm flex flex-center"
            style="justify-content: center;flex-wrap: wrap;"
          >
            <router-link to="/gaikuang/18">高新概况</router-link>
            <span>|</span>
            <a href="http://bdgx.hbzwfw.gov.cn/" target="_blank">政务服务</a>
            <span>|</span>
            <a href="https://www.bdgxq.gov.cn/zwgk/index.html#/" target="_blank"
              >政务公开</a
            >
            <span>|</span>
            <router-link to="/Ztzl">专题专栏</router-link>
            <span>|</span>
          </div>
          <div>
            <router-link to="/Gzly">公众留言</router-link>
            <span>|</span>
            <router-link to="/Maps">网站地图</router-link>
          </div>
        </div>
        <p class="margin-bottom-sm footer_p">
          <span>主办单位：保定国家高新技术产业开发区管理委员会</span>
          <span style="padding-left: 10px;">电话：0312-3108801</span>
        </p>
        <div class="footer_beian">
          <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
            >冀ICP备13016902号-1
          </a>
          <span>
            网站标识：1306000020
          </span>
          <a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13065202000377"
            target="_blank"
          >
            公安机关备案：13065202000377
          </a>
        </div>
      </div>
      <a
        href="https://zfwzgl.www.gov.cn/exposure/jiucuo.html?site_code=1306000020&url=http%3A%2F%2Fwww.bdgxq.gov.cn%2F"
        target="_blank"
      >
        <img src="@/assets/chacuo.png" alt="" class="img2" />
      </a>
    </footer>
  </div>
</template>
<script>
export default {
  name: "Fotters",
};
</script>
<style>
.footer {
  color: rgba(80, 80, 80, 1);
  background-color: rgba(238, 238, 238, 1);
  font-size: 14px;
  line-height: 150%;
  text-align: center;
  /* height: 200px; */
  padding: 40px 0;
  margin-top: 0px;
}

.footer_btm {
  display: flex;
  flex-wrap: wrap;
}
.footer_btm span {
  padding: 0 3px;
}
@media screen and (min-width: 1200px) {
  .footer .img1 {
    width: 80px;
    height: 80px;
  }
  .footer .img2 {
    width: 110px;
  }
}
@media screen and (min-width: 769px) and (max-width: 1199px) {
  .footer .img1 {
    width: 70px;
    height: 70px;
  }
  .footer .img2 {
    width: 100px;
  }
}
@media screen and (max-width: 768px) {
  .footer .img1 {
    width: 50px;
    height: 50px;
  }
  .footer .img2 {
    width: 60px;
  }
  .footer_btm {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
  }
  .footer_p {
    display: flex;
    flex-direction: column;
  }
  .footer_beian {
    display: flex;
    flex-direction: column;
  }
  .footer {
    flex-direction: column;
  }
}
.btms {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
